import React, {ReactNode, useContext} from "react";
import {Link} from "react-router-dom";
import Organization from "../../domain/Organization";
import {AppContextContext} from "../../Contexts";

export function renderOrganizationLink(organization?: Organization | null, fallback?: ReactNode) {
    return <OrganizationLink organization={organization} fallback={fallback}/>;
}

function OrganizationLink({organization, fallback}: { organization?: Organization | null; fallback?: ReactNode }) {
    const appContext = useContext(AppContextContext);
    const label = organization?.name ?? fallback;

    if (!organization?.id) {
        return label ?? null;
    }

    if (!appContext.user.isSystemAdmin()) {
        return label ?? null;
    }

    return <Link to={`/organizations/${organization.id}`}>{label}</Link>;
}
